export default __webpack_public_path__ + "static/DualEmblem-4a415b33cd36232f69e11c47cc622233.jpg";